import { dig, hasProp, toArray } from 'vessel/utils'

function getCurrentValue(value, id) {
  return value && dig(value, id)
}

function getInitialState(data) {
  return data && data.$enableWhen
    ? toArray(data.$enableWhen).some(item => item.$default == true)
    : true
}

export default {
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler() {
        this.$nextTick(() => {
          this.updateEnableWhenStatus()
        })
      }
    }
  },
  data() {
    return {
      inputEnabled: getInitialState(this.data)
    }
  },
  computed: {
    _show() {
      return this.inputEnabled == true
    }
  },
  methods: {
    getEnableWhenStatus(config) {
      const enableSingleItem = (enableWhen) => {
        if (typeof enableWhen === 'string')
          return getCurrentValue(this.value, enableWhen) !== undefined

        const defaultEnabled = enableWhen.$default == true

        for (const id in enableWhen) {
          if (hasProp(id, enableWhen) && !id.startsWith('$')) {
            const currentValue = getCurrentValue(this.value, id)

            if (defaultEnabled && (!currentValue || currentValue === ''))
              return true

            if (currentValue === undefined || currentValue === '')
              return false

            if (!enableWhen[id] && currentValue === '')
              return false

            if (enableWhen[id] !== undefined && currentValue !== enableWhen[id])
              return false
          }
        }

        return true
      }

      if (config) {
        return toArray(config).some(enableSingleItem)
      } else {
        return true
      }
    },
    updateEnableWhenStatus() {
      if (!this.data) return

      const { $enableWhen, $disableWhen } = this.data
      if (!$enableWhen && !$disableWhen) return

      const enable  = $enableWhen ? this.getEnableWhenStatus($enableWhen) : true
      const disable = $disableWhen ? this.getEnableWhenStatus($disableWhen) : false

      this.inputEnabled = enable && !disable
    }
  }
}
